export const CHANGE_TEMPLATE = 'CHANGE_TEMPLATE'
export const EXIT = 'EXIT'
export const PREVIEW = 'PREVIEW'
export const STRUCTURE = 'STRUCTURE'
export const CLOSE_PREVIEW = 'CLOSE_PREVIEW'
export const SAVE_EXIT = 'SAVE_EXIT'
